import React, {FC, ReactNode} from 'react';
import {Dialog, DialogBody, Menu, MenuItem} from '@mc/ui-v4';
import {TopicVO} from '../../api';

type Props = {
    onClose: () => void;
    topics: TopicVO[];
    selectedTopicId: string;
    onSelect: (topicId: string) => void;
};

const TopicSelectDialog: FC<Props> = ({onClose, topics, selectedTopicId, onSelect}) => (
    <Dialog isOpen size={'sm'} title={'Výběr tématu'} onClose={onClose} isCloseButtonShown escapeKeyClose outsideClickClose>
        <DialogBody className={'p-0'}>
            <Menu className="select-scroll">
                {topics?.map(
                    (item: TopicVO): ReactNode => (
                        <MenuItem
                            active={item.id === selectedTopicId}
                            key={item.id}
                            onClick={() => {
                                onSelect(item.id);
                                onClose();
                            }}
                            text={item.label}
                        />
                    ),
                )}
            </Menu>
        </DialogBody>
    </Dialog>
);

export default TopicSelectDialog;
